import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { Paper } from '../paper'

import s from './styles.module.scss'

interface Props {
  title: string
  subtitle: string
  onClick?: () => void
}

export const RecentSearchCard: FC<Props> = ({ title, subtitle, onClick }) => {
  return (
    <Paper
      padding={[8, 16]}
      radius="20px"
    >
      <div
        className={s.container}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
      >
        <div className={s.left}>
          <AppIcon
            id={AllIcons.AIRPLANE_BIG_FILLED}
            className={s.icon}
            width={18}
            height={18}
            color="var(--grey-soft)"
          />
        </div>
        <div className={s.right}>
          <p className={clsx(s.title, 'regular-16')}>{title}</p>
          <p className={clsx(s.subTitle, 'regular-12')}>{subtitle}</p>
        </div>
      </div>
    </Paper>
  )
}
